import { WidgetColumn } from '@framework/engine-ui/dnd/layout/WidgetColumn.tsx';
import { WidgetRow } from '@framework/engine-ui/dnd/layout/WidgetRow.tsx';
import React from 'react';
import { type Widget } from '../../widgets/Widget.ts';
import { FillableWidget } from './FillableWidget.tsx';

export interface IFillableWidgetListProps {
  widgets: Widget[];
  parent?: Widget;
  readonly?: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Lista di tutti i componenti widget di un form.
 * Memoizzato per evitare di ricreare il JSX di tutti i figli quando
 * il parent re-rende per context changes senza cambiare le props.
 */
export const FillableWidgetList = React.memo(function FillableWidgetList(
  props: IFillableWidgetListProps,
) {
  const { widgets, parent, readonly } = props;

  return (
    <WidgetRow gutter={[24, 0]}>
      {widgets.map(widget => (
        <WidgetColumn parent={parent} widget={widget} key={widget.id}>
          <FillableWidget
            widget={widget}
            parent={parent}
            readonly={readonly}
            isReadonly={props.isReadonly}
          />
        </WidgetColumn>
      ))}
    </WidgetRow>
  );
});
